<div class="layout-ParentDiv innerDiv">
    <div class="layout-dashboard addPage roleAddPage">
        <div class="p-grid">
            <div class="p-col-12 mainFormPadding">
                <div class="card">
                    <p-toast key="toastmsg" position="top-right"></p-toast>
                    <form [formGroup]="roleForm" *ngIf="this.roleForm" (ngSubmit)="onSubmit()">
                        <div class="p-fluid p-formgrid p-grid m-0">
                            <div class="p-field p-col-12 div-border p-p-0">
                                <h3 class="head-page-title">
                                    Edit Role
                                </h3>
                            </div>
                        </div>
                        <div class="p-fluid p-formgrid p-grid">
                            <div class="p-field p-col-12 p-fluid p-formgrid p-grid mainFormGap">
                                <div class="p-field p-col-4">
                                    <label for="rolename">Name</label>
                                    <input formControlName="rolename" type="text" pInputText class="form-control"
                                        [ngClass]="{ 'is-invalid': submitted && f.rolename.errors }">
                                    <div *ngIf="submitted && f.rolename.errors" class="invalid-feedback">
                                        <div *ngIf="f.rolename.errors.required">Role Name is required</div>
                                        <div *ngIf="f.rolename.errors">Numbers, Space and Special characters not
                                            allowed.</div>
                                    </div>
                                </div>
                                <div class="p-field p-col-4  statusdivMain">
                                    <label for="firstname6">Status</label>
                                    <p-inputSwitch class="checkbox-mt-10" formControlName="status"></p-inputSwitch>
                                </div>
                                <!-- <div class="p-field ">
                                    <label for="status">Status</label>
                                    <p-dropdown inputId="status" [options]="statuses" formControlName="status"
                                        placeholder="Select" optionLabel="label"
                                        (ngModelChange)="onStatusSelect($event)"></p-dropdown>
                                    <div *ngIf="submitted && f.status.errors" class="invalid-feedback">
                                        <div *ngIf="f.status.errors.required">Please, Select Status</div>
                                    </div>
                                </div> -->
                                <div class="p-field p-col-12">
                                    <label for="description">Description</label>
                                    <textarea inputId="textarea" rows="3" cols="30" formControlName="description"
                                        pInputTextarea></textarea>
                                </div>
                                <div class="p-field p-col-12">
                                    <div class="lineborderHR">
                                        <hr>
                                    </div>
                                </div>

                            </div>
                        </div>

                        <div class="p-col-12 p-lg-12 p-p-0">
                            <div class="p-field p-col-12 div-border p-p-0">
                                <h4 class="subHeadingTitle">Module List</h4>
                            </div>
                            <div class=" p-col-12 p-pl-0 p-pt-1  p-pb-1">
                                <div class="checkbox-div">
                                    <span class="text-left">
                                        <p-checkbox binary="true" (onChange)="selectAll($event);"
                                            formControlName="selectAll" value="selectAll"></p-checkbox>
                                    </span>
                                    <label for="selectAll">Select All Module List</label>
                                    <div *ngIf="permissionerrors" style="color:red;">
                                        <div>Please, Select Atleast 1 module</div>
                                    </div>
                                </div>
                            </div>


                            <p-panel *ngFor="let module of  moduleList ;let i = index;" [toggleable]="true"
                                [collapsed]="false" toggler="header" header="{{module.module | titlecase }}">
                                <div class="mainMenues">
                                    <p-content>
                                        <div class="mainMenuesList d-flex">
                                            <div class="text-left">
                                                <p-checkbox binary="true"
                                                    (onChange)="setModuleCheckbox($event, module.module, module);"
                                                    formControlName="{{module.module}}"
                                                    value="{{module.module}}"></p-checkbox>
                                                <span class="modulename">{{module.module | titlecase }}</span>
                                            </div>
                                            <div class="right">
                                                <p-radioButton value="edit"
                                                    (onClick)="setModuleRadiobutton($event, module.module, 'edit');"
                                                    label="Edit"
                                                    formControlName="{{module.module}}_radio"></p-radioButton>
                                                <p-radioButton value="view"
                                                    (onClick)="setModuleRadiobutton($event, module.module, 'view');"
                                                    label="View"
                                                    formControlName="{{module.module}}_radio"></p-radioButton>
                                            </div>
                                        </div>


                                    </p-content>
                                </div>

                                <div class="sub-menus-div" *ngIf="module.submodule">
                                    <p-content *ngFor="let submodule of module.submodule; let sub = index"
                                        class="sub-menus">
                                        <div class="mainSubMenuesList d-flex">
                                            <div class="submodule text-left">
                                                <p-checkbox binary="true"
                                                    (onChange)="setSubModuleCheckbox($event, submodule, module.module);"
                                                    formControlName="{{submodule.module}}"
                                                    value="{{submodule.module}}"></p-checkbox>
                                                <span class="title-name">{{submodule.module | titlecase }}</span>
                                            </div>
                                            <div class="right">
                                                <p-radioButton value="edit"
                                                    (onClick)="setSubModuleRadiobutton($event, submodule.module, module.module, 'edit');"
                                                    label="Edit" id="edit"
                                                    formControlName="{{submodule.module}}_radio"></p-radioButton>
                                                <p-radioButton value="view"
                                                    (onClick)="setSubModuleRadiobutton($event, submodule.module, module.module, 'view');"
                                                    label="View" id="view"
                                                    formControlName="{{submodule.module}}_radio"></p-radioButton>
                                            </div>
                                        </div>
                                    </p-content>
                                </div>

                            </p-panel>
                        </div>
                        <div class="text-center button-set p-col-12 d-flex p-fluid p-jc-md-end bottom-footer">
                            <div class="footer-btn d-flex">
                                <button pButton pRipple label="Save" icon="pi pi-check"
                                    class="p-button-success save-btn p-mr-3"></button>
                                <!-- <button pButton pRipple label="Reset" icon="pi pi-history" type="reset"
                                    (click)="onReset()" class="p-button-info save-btn p-mr-3"></button> -->
                                <!-- <button pButton pRipple label="Save" icon="pi pi-check" [disabled]="userForm.invalid"></button> -->
                                <button pButton pRipple type="button" label="Cancel"
                                    class=" p-button-danger cancel-btn p-mr-0" icon="pi pi-times"
                                    (click)="backLink()"></button>
                            </div>
                        </div>
                    </form>
                </div>
                <div class="button-set back">
                    <div class="p-fluid p-formgrid">
                        <p-toast></p-toast>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>